<mat-toolbar class="w-full bg-color">
      <div class="w-1/3">
        <button
          type="button"
          mat-icon-button
          *ngIf="!showGoBackButton"
          (click)="onOpenMenu.emit(true)"
        >
          <img src="./assets/icons/menu.svg" />
        </button>
        <button mat-icon-button *ngIf="showGoBackButton" (click)="goBack()">
          <img src="./assets/icons/back.svg" />
        </button>
      </div>
      <div class="w-1/3 flex justify-center">
        <img style="width: 100px;height:45px" src="./assets/icons/zendy.svg" />
      </div>
      <div class="w-1/3 flex justify-end items-center">
        <!-- Muestra el selector solo si hay más de un portal -->
        <mat-select *ngIf="hasMultiplePortals" placeholder="Portal" (selectionChange)="selectPortal($event.value)"   style="color: #ffff; font-size: 14px;max-width: 150px;"> 
          <mat-option *ngFor="let portal of portals" [value]="portal">
            {{ portal | titlecase }}
          </mat-option>
        </mat-select>
        <app-languages *ngIf="!showGoBackButton"></app-languages>
        
        <button mat-icon-button routerLink="recharges">
          <img *ngIf="!showGoBackButton" src="./assets/icons/wallet.svg" />
        </button>
      </div>
    </mat-toolbar>
    <ng-container [ngSwitch]="showTabsOrSidenav">
        <app-tabs *ngSwitchCase="'tabs'"></app-tabs>
        <app-backoffice *ngSwitchCase="'backoffice'"></app-backoffice>
        <!-- <app-btb *ngSwitchCase="'btb'"></app-btb> -->
    </ng-container>